import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Icon from "@/components/Icon.vue";
import "./app.pcss";

import * as Sentry from "@sentry/vue";

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://aab2336cb9b75e30b7799eb874791548@o108350.ingest.us.sentry.io/4509248846233600",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

app.component("Icon", Icon);
app.use(router);
app.use(store);

// Initialize dark mode
store.dispatch("initDarkMode");

app.mount("#app");
